import Component from './TextTruncate.vue';

export const TextTruncate = Component;

export default ('ActiveXObject' in window && !window.attachEvent) ? Component : {
    functional: true,
    render(h, context) {
        const { staticClass, ...rest } = context.data;
        const classes = [];
        if (staticClass) {
            classes.push(staticClass);
        }
        const data = {
            // eslint-disable-next-line max-len
            staticClass: classes.concat('patsnap-biz-text_truncate', `patsnap-biz-text_truncate--${context.props.lines || 2}`).join(' '),
            ...rest,
        };
        return h(context.props.tag || 'div', data, context.children);
    },
};
